import { requestApi } from '../util/network'

// 获取用户平台代金券列表
export const getMallVoucherList =
(params,stateType) =>
  requestApi(
    '/Membermallvoucher/mallvoucher_list',
    'POST',
    {
        page:params.page,
        per_page:params.per_page,
        mallvoucher_state:stateType
    },
    'member'
  )
// 获取用户店代金券列表
export const getVoucherList =
(params,stateType) =>
  requestApi(
    '/Membervoucher/voucher_list',
    'POST',
    {
        page:params.page,
        per_page:params.per_page,
        voucher_state:stateType
    },
    'member'
  )

// 兑换代金券
export const receiveVoucher =
    (vouchertemplate_id) =>
      requestApi(
        '/Membervoucher/voucher_point',
        'POST',
        {
          'tid': vouchertemplate_id
        },
        'member'
      )
// 私密代金券
export const getVoucherPrivate =
    (vouchertemplate_id) =>
      requestApi(
        '/Membervoucher/voucher_private',
        'POST',
        {
          'vouchertemplate_id': vouchertemplate_id
        },
        'member'
      )
